import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const FormaterNapr = (props) => {
      const { value } = props
      if (value !== null && typeof value  === 'number' && value == 1) 
        return <div style={{textAlign: props.Align, fontWeight: 'bold', fontSize:'16pt'}} title='Входящие'>
                 ↓В
               </div>
      else {
        if (value !== null && typeof value  === 'number' && value == 2) 
            return <div style={{textAlign: props.Align, fontWeight: 'bold', fontSize:'16pt' }} title='Исходящие'>
                    ↑И
                </div>
        else
            return null
      }
  }

  export default FormaterNapr;  